import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { REDUX_STORE } from '../../../constants/common';
import {
  addArticleWithReadyToShowComments,
  resetArticlesWithReadyToShowComments,
  selectMaterialByAlias,
} from '../../../reducers/news';
import { isServer } from '../../../utils/isServer';

let observer: IntersectionObserver;

const handleIntersect: IntersectionObserverCallback = (entries) => {
  const { getState, dispatch } = window[REDUX_STORE];

  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const articleAlias = (entry.target as HTMLElement).dataset?.alias;
      const material = selectMaterialByAlias(getState())(articleAlias);
      dispatch(addArticleWithReadyToShowComments(material.id));
    }
  });
};

export const useCommentsObserver = () => {
  const dispatch = useDispatch();

  if (!observer && !isServer) {
    observer = new IntersectionObserver(handleIntersect, {
      rootMargin: `0px 0px 200px 0px`,
    });
  }

  useEffect(() => {
    return () => {
      dispatch(resetArticlesWithReadyToShowComments());
      observer.disconnect();
      observer = null;
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return observer;
};
